import { render, staticRenderFns } from "./BehindertenFoerderung.vue?vue&type=template&id=1a379960&"
import script from "./BehindertenFoerderung.vue?vue&type=script&lang=js&"
export * from "./BehindertenFoerderung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports